import { connect } from 'react-redux';
import { getCurrentWrapup } from 'project/ducks/wrapup';
import Wrapup from 'project/components/wrapup';

const mapStateToProps = (state, { params }) => ({
  user: state.user.profile_data,
  wrapup: getCurrentWrapup(state, params.awardId),
});

export default connect(mapStateToProps)(Wrapup);



// WEBPACK FOOTER //
// ./project/containers/wrapup/index.js